import { motion } from "framer-motion";
import { Mail, MapPin } from "lucide-react";

const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_construct-compliance/artifacts/jecks2sa_image.png";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "About", href: "#about" },
  { label: "Clients", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="relative border-t border-white/10 bg-secondary/40" data-testid="footer">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Qonnect QA" className="h-11 w-11 rounded-lg object-cover" />
            <span className="font-heading font-semibold text-xl">Qonnect<span className="text-primary"> QA</span></span>
          </div>
          <p className="mt-5 font-heading text-2xl font-light tracking-tight text-foreground/90 max-w-sm">
            Engineering trust, <span className="text-primary">delivering quality.</span>
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">Navigate</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.href}>
                <button onClick={() => go(n.href)} className="text-foreground/80 hover:text-primary transition-colors" data-testid={`footer-link-${n.label.toLowerCase()}`}>
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">Get in touch</h4>
          <a href="mailto:lokesh.w@outlook.in" className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors" data-testid="footer-email">
            <Mail size={18} /> lokesh.w@outlook.in
          </a>
          <div className="flex items-center gap-3 text-foreground/80 mt-3">
            <MapPin size={18} /> India
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
          <span>&copy; {new Date().getFullYear()} Qonnect QA. All rights reserved.</span>
          <span>Construction Quality Inspection &amp; QA/QC Consultancy</span>
        </div>
      </div>
    </footer>
  );
}
